<template>
  <BaseDialog :title="tagDistDialogConfig.title" :visible="tagDistDialogVisible" append-to-body width="850px" @close="close">
    <template slot="body">
      <div class="routerContent">
          <div class="card df p10">
              <el-button type="primary" @click="editData()">新增</el-button>
              <el-button type="primary" @click="batchDelete()">批量删除</el-button>
              <div class="fg1"></div>
              <el-input class="topSearch" placeholder="请输入分配人" clearable v-model="searchForm.distUserName"
                        style="width: 300px; height: 30px">
                  <el-button slot="append" icon="el-icon-search" @click="initData"></el-button>
              </el-input>
              <!-- <el-button icon="el-icon-s-operation" class="ml10" @click="showForm = !showForm" style="font-size: 14px"
                         type="text">高级搜索
              </el-button> -->
          </div>
          <!-- <pageDialog class="card" v-model="showForm">
              <el-form :model="searchForm" label-width="70px"  label-position="top" ref="searchForm">
                          <el-form-item label="标签申请ID">
                              <el-input v-model="searchForm.tagApplyId"  placeholder="请输入标签申请ID" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="标签数量">
                              <el-input v-model="searchForm.distSl"  placeholder="请输入标签数量" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="起始标签码">
                              <el-input v-model="searchForm.distKsbqm"  placeholder="请输入起始标签码" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="结束标签码">
                              <el-input v-model="searchForm.distJsbqm"  placeholder="请输入结束标签码" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="分配人姓名">
                              <el-input v-model="searchForm.distUserName"  placeholder="请输入分配人姓名" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="分配时间" prop="distTime">
                              <el-date-picker v-model="searchForm.distTime" type="date" editable placeholder="请输入分配时间" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
                          </el-form-item>
                          <el-form-item label="备注">
                              <el-input v-model="searchForm.distDesc"  placeholder="请输入备注" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="创建人">
                              <el-input v-model="searchForm.createId"  placeholder="请输入创建人" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="创建人姓名">
                              <el-input v-model="searchForm.createName"  placeholder="请输入创建人姓名" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="创建时间" prop="createTime">
                              <el-date-picker v-model="searchForm.createTime" type="date" editable placeholder="请输入创建时间" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
                          </el-form-item>
              </el-form>
              <div class="df jce" slot="footer">
                  <el-button @click="reset">重置</el-button>
                  <el-button type="primary" @click="getData('refresh')">查询</el-button>
              </div>
          </pageDialog> -->
          <jh-table class="fg1 ova" height="300px" size="small" :stripe="true" row-key="tagDistId" ref="jhTable" :columnList="columnList"
                    :data="dataList" @selection-change="handleSelectionChange" @deleteData="delData"/>
          <div class="tc pt10 pb10">
              <jh-pager :pager.sync="pager" @getData="getData"/>
          </div>

          <infoDialog @onSuccess="getData" :infoDialogConfig="infoDialogConfig" v-if="infoDialogVisible"
                      :infoDialogVisible.sync="infoDialogVisible"/>
          <!-- <selectColumnDialog v-model="showSelect" :columnList="allColumnList" :selectCol.sync="selectCol" width="200px"/> -->
      </div>
    </template>
  </BaseDialog>
</template>

<script>
    export default {
        components: {
            infoDialog: (resolve) => resolve(require("./components/infoDialog")),
        },
        props: {
          tagDistDialogConfig: {
            type: Object,
            default: () => {
            },
          },
          tagDistDialogVisible: {
            type: Boolean,
            default: () => false,
          },
        },
        data() {
            return {
                tzcList:[],
                pager: {
                    size: 20,
                    total: 0,
                    page: 1,
                },
                showForm: false, //高级搜索
                showSelect: false, //表格动态列
                options: [], //模块数组
                searchForm: {
                    tagDistId: '',
                    tagApplyId: '',
                    distSl: '',
                    distQyid: '',
                    distKsbqm: '',
                    distJsbqm: '',
                    distUserId: '',
                    distUserName: '',
                    distTime: '',
                    distDesc: '',
                    createId: '',
                    createName: '',
                    createTime: '',
                },
                infoDialogVisible: false,
                infoDialogConfig: {
                    title: "添加信息",
                },
                dataRoleTypes: [],
                dataList: [], //表格数据
                selectList: [], //选中数组
                selectCol: [], //选中列
                //表格列数组  不是用动态列可以直接赋值给columnList 不需要computed
                allColumnList: [{
                    type: "selection",
                    align: "center",
                    reserveSelection: true, //与表格的row-key配合使用 实现跨页选中
                },
                    {
                        type: "index",
                        align: "center",
                    },
                    {
                        prop: "distTzcmc",
                        label: "屠宰场名称",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "distSl",
                        label: "标签数量",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "distKsbqm",
                        label: "起始标签码",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "distJsbqm",
                        label: "结束标签码",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "distUserName",
                        label: "分配人姓名",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "distTime",
                        label: "分配时间",
                        align: "center",
                        minWidth: "120px",
                        render: (h, scope) => {
                          return h(
                            "div",
                            this.formatDate(scope.row.distTime, "yyyy-MM-dd")
                          );
                        },
                    },
                    // {
                    //     prop: "distDesc",
                    //     label: "备注",
                    //     align: "center",
                    //     minWidth: "120px",
                    // },
                    // {
                    //     prop: "createName",
                    //     label: "创建人姓名",
                    //     align: "center",
                    //     minWidth: "120px",
                    // },
                    // {
                    //     prop: "createTime",
                    //     label: "创建时间",
                    //     align: "center",
                    //     minWidth: "100px",
                    //     render: (h, scope) => {
                    //         return h(
                    //             "div",
                    //             this.formatDate(scope.row.createTime, "yyyy-MM-dd")
                    //         );
                    //     },
                    // },
                    {
                        prop: "",
                        fixed: "right",
                        label: "操作",
                        align: "center",
                        width: "120px",
                        renderHeader: (h, scope) => {
                            return h(
                                "div", {
                                    class: {
                                        df: true,
                                        aic: true,
                                        jcb: true,
                                        pl10: true,
                                        pr10: true,
                                    },
                                },
                                [
                                    h("div", {}, []),
                                    h(
                                        "div", {
                                            domProps: {
                                                innerHTML: "操作",
                                            },
                                        },
                                        []
                                    ),
                                    h(
                                        "i", {
                                            class: {
                                                "el-icon-s-operation": true,
                                                poi: true,
                                            },
                                            style: {
                                                fontSize: "20px",
                                            },
                                            on: {
                                                click: () => (this.showSelect = !this.showSelect),
                                            },
                                        },
                                        []
                                    ),
                                ]
                            );
                        },
                        render: (h, scope) => {
                            return h("div", {}, [
                                h("el-button", {
                                    on: {
                                        click: this.editData.bind(this, scope.row),
                                    },
                                    props: {
                                        type: "text",
                                    },
                                    domProps: {
                                        innerHTML: "修改",
                                    },
                                }),
                                h("el-button", {
                                    on: {
                                        click: scope._self.deleteRow.bind(this, scope.row),
                                    },
                                    props: {
                                        type: "text",
                                    },
                                    domProps: {
                                        innerHTML: "删除",
                                    },
                                }),
                            ]);
                        },
                    },],
            };
        },
        computed: {
            columnList: function () {
                return this.allColumnList.filter(
                    (item) =>
                        !item.label ||
                        this.selectCol.includes(item.label) ||
                        item.label === "操作"
                );
            },
        },


        async mounted() {
          if (this.tagDistDialogConfig){
            this.searchForm.tagApplyId=this.tagDistDialogConfig.tagApplyId;
          }
          await this.doGetComp();
          await this.getData();
        },

        created() {
            this.selectCol = this.allColumnList
                .map(item => item.label)
                .filter(item => item && item != "操作");
        },
        methods: {
            close() {
              this.$emit("update:tagDistDialogVisible", false);
            },
            handleSelectionChange(row) {
                this.selectList = row;
            },
            batchDelete() {
                if (this.selectList.length === 0) {
                    this.$message.warning("当前未选择数据");
                    return;
                }
                this.$confirm("此操作将永久删除这些项, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let params = [];
                        for (let i = 0; i < this.selectList.length; i++) {
                            params[i] = this.selectList[i].tagDistId;
                        }
                        this.$api.formPost("/api/major/tag/tagDist/doRmByIds", {
                            ids: params
                        }).then((res) => {
                            this.selectList = [];
                            this.$refs.jhTable.$refs.formTable.clearSelection();
                            this.$message.success("删除成功");
                            this.getData();
                        });
                    })
                    .catch(() => {
                    });
            },

            getData(type) {
                if (type === "refresh") {
                    this.pager.page = 1;
                }
                let params = {
                    pageNum: this.pager.page,
                    pageSize: this.pager.size,
                    ...this.searchForm,
                };
                this.showForm = false;
                this.$api
                    .formPost("/api/major/tag/tagDist/doGetList", params)
                    .then((res) => {
                        if (res.retHead.code == "0000000") {
                            this.dataList = res.retBody.list;
                            this.dataList.forEach(item => {
                                this.tzcList.forEach(tzc=>{
                                    if(tzc.compId = item.distQyid){
                                        item.distTzcmc = tzc.compMc
                                    }
                                })
                            });
                            this.pager.total = res.retBody.total;
                        }
                    })
            },
            // 编辑
            editData(row) {
                this.infoDialogConfig.tzcList = this.tzcList;
                if (row) {
                    this.infoDialogConfig.title = "修改信息";
                    this.infoDialogConfig.data = JSON.parse(JSON.stringify(row));
                } else {
                    this.infoDialogConfig.title = "添加信息";
                    this.infoDialogConfig.data = null;
                }
                this.infoDialogConfig.tagApplyId = this.searchForm.tagApplyId;
                this.infoDialogVisible = true;
            },
            delData(row) {
                let params = {
                    id: row.tagDistId,
                };
                this.$api
                    .formPost("/api/major/tag/tagDist/doRmById", params)
                    .then((res) => {
                        this.$message.success("删除成功");
                        this.getData();
                    });
            },
            reset() {
                this.$refs.searchForm.resetFields();
                for (const key in this.searchForm) {
                    this.searchForm[key] = "";
                }
                this.searchForm.compId = JSON.parse(sessionStorage.getItem('user')).organId,
                this.searchForm.organRecurFlag = '1'
                this.currentPage = 1;
                this.getData("refresh");
            },
            initData() {
                this.getData("refresh");
            },
            doGetComp(){
                this.$api
                .formPost("/api/major/sycomp/doGetSysComps", {
                    compLx:'2',
                })
                .then((res) => {
                    if (res.retHead.code == "0000000") {
                        this.tzcList = res.retBody;
                    }
                });
            },



        },
    };
</script>

<style lang="scss" scoped>
  .userInfo {
    width: 240px;
    display: flex;
    flex-direction: column;
    height: 100%;

    .info {
      font-size: var(--text-size);
      display: flex;
      justify-content: space-between;
      padding: 13px 0px;
      border-bottom: 1px solid #ccc;

      .title {
        min-width: 70px;
      }
    }
  }

  .avatar-uploader {
    width: 100%;
    border: 1px dotted #ccc;
    text-align: center;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 240px;
    line-height: 240px;
    text-align: center;
  }

  .avatar {
    width: 240px;
    height: 240px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/tag/tagDist/tagDist.vue